export interface GridResult<T> {
  result: T[];
  count: number;
}

export const toGridResult = <T>(data: any[], count: number): GridResult<T> => ({
  result: data as T[],
  count,
});
